import React from "react";
import Header from "gatsby-theme-carbon/src/components/Header";

const CustomHeader = (props) => (
  <Header {...props}>
    Cúram on Kubernetes
  </Header>
);

export default CustomHeader;
